
import { useNavigate } from 'react-router-dom';

export default function ThreeRegionsSection() {
  const navigate = useNavigate();

  const handleLearnMore = () => {
    navigate('/about');
  };

  return (
    <section className="py-12 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8">
          <h2 className="text-xl md:text-2xl font-bold text-[#2f3673] mb-2">一门匠心，三地淬炼</h2>
          <p className="text-sm md:text-base text-gray-600 max-w-2xl mx-auto">
            融汇香港国际标准、云南道地药材、泰国草本精华，打造男性养生新境界
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
          {/* 香港 - 国际标准 */}
          <div className="relative group">
            <div className="relative h-64 rounded-2xl overflow-hidden">
              <img
                src="https://static.readdy.ai/image/2e1ac11483faca2c19cd44d7d582b015/69fc7b1a1b05c2599bdbfcd823225c54.jfif"
                alt="香港国际标准"
                className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent"></div>
              <div className="absolute inset-0 flex flex-col justify-end p-4">
                <h3 className="text-lg font-bold text-white mb-1">香港</h3>
                <p className="text-xs text-gray-200 mb-2">国际化标准</p>
                <div className="flex flex-wrap gap-1">
                  <span className="px-2 py-1 bg-white/20 rounded-full text-xs text-white">GMP认证</span>
                  <span className="px-2 py-1 bg-white/20 rounded-full text-xs text-white">国际品控</span>
                </div>
              </div>
            </div>
          </div>

          {/* 云南 - 道地药材 */}
          <div className="relative group">
            <div className="relative h-64 rounded-2xl overflow-hidden">
              <img
                src="https://static.readdy.ai/image/2e1ac11483faca2c19cd44d7d582b015/c4d5b2b029cacc50c5be4fb6277bc215.jfif"
                alt="云南道地药材"
                className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent"></div>
              <div className="absolute inset-0 flex flex-col justify-end p-4">
                <h3 className="text-lg font-bold text-white mb-1">云南</h3>
                <p className="text-xs text-gray-200 mb-2">道地药材</p>
                <div className="flex flex-wrap gap-1">
                  <span className="px-2 py-1 bg-white/20 rounded-full text-xs text-white">道地药材</span>
                  <span className="px-2 py-1 bg-white/20 rounded-full text-xs text-white">天然纯正</span>
                </div>
              </div>
            </div>
          </div>

          {/* 泰国 - 草本精华 */}
          <div className="relative group">
            <div className="relative h-64 rounded-2xl overflow-hidden">
              <img
                src="https://static.readdy.ai/image/2e1ac11483faca2c19cd44d7d582b015/40a7ebcf307813d67815b695b9e6b8c1.jfif"
                alt="泰国草本精华"
                className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent"></div>
              <div className="absolute inset-0 flex flex-col justify-end p-4">
                <h3 className="text-lg font-bold text-white mb-1">泰国</h3>
                <p className="text-xs text-gray-200 mb-2">草本精华</p>
                <div className="flex flex-wrap gap-1">
                  <span className="px-2 py-1 bg-white/20 rounded-full text-xs text-white">热带活力</span>
                  <span className="px-2 py-1 bg-white/20 rounded-full text-xs text-white">华人秘方</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="text-center">
          <button 
            onClick={handleLearnMore}
            className="bg-[#f7931d] text-white px-6 py-2 rounded-full text-sm font-semibold hover:bg-[#e6841a] transition-colors duration-300 cursor-pointer whitespace-nowrap"
          >
            了解更多三地故事
          </button>
        </div>
      </div>
    </section>
  );
}
